import { Partner } from 'src/types';

const defaults: Readonly<Partner> = {
  id: 0,
  links: [],
  metaTagDescription: null,
  name: '',
  logo: '',
  relatedProducts: [],
  shortcode: '',
  location: '',
};

export const partnerBuilder = (partner?: Partial<Partner>): Readonly<Partner> => ({
  ...defaults,
  ...partner,
});
